import React, { useContext } from "react";
import TableAnalytics from './Table';
import { GlobalContext } from "../../../context/GlobalState";

export default function TeacherUsage () {
  document.title = "2xcell.in";
  const {userDetails} = useContext(GlobalContext);
  return (
    <>
      <section className="my-5">
        <div className="container">
          <h1>{userDetails.role === "teacher"?"Usage Report":"Usage Report"}</h1>
          <div className="mt-2">
            <TableAnalytics />
          </div>
        </div>
      </section>
    </>
  );
};